import { notification } from 'antd';

export default function toasts(state = {
  toasts: [],
}, action) {
  switch (action.type) {
    case 'ADD_TOAST': {
      const { kind, message: description, timeout } = action.payload;
      const notificationType = ['error', 'success'].includes(kind) ? kind : 'info';
      notification[notificationType]({
        duration: Number(timeout) / 1000,
        className: 'notification-antd-crimsom-community',
        message: description,
        description: description,
      });
      return state;
    }
    default:
      return state;
  }
}
